import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';

export function fireNoStreamIdTracking(error, creativeId, id) {
  if (error?.name !== 'AbortError') {
    EventToolbox.fireTrackAction({
      event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
      event_data: {
        action_name: TrackingConstant.ACTION_SHOW_CONTENT,
        action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
        action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
        creative_id: creativeId,
        subaction_name: 'canvas_error',
        value: `${error?.status}-no_stream_id`,
        ...(id ? { resp_uuid: id } : {}),
      },
    });
  }
}
